module.exports = __webpack_public_path__ + "img/img_covertack_color.aeb5af47.png";